import React from "react";
import Select from "react-select";
import { useDispatch } from "react-redux";
import {
  changeFloaterFrame,
  changePaperType,
  changeBleed,
} from "../redux/creators/fabricCreators";
import styled from "styled-components";

const OptionSelect = ({ options, selected, onSelect }) => {
  const result = options.map((opt) => {
    const { label, image, value } = opt;
    const splitLabel = String(label).split(" ");
    let imageUrl = image;

    if (label.includes("Blur") == true && window.is_ab_custom_pdp == true) {
      imageUrl =
        "https://cdn.shopify.com/s/files/1/0257/4522/7828/files/blur_ab_border.png";
    } else if (
      label.includes("Black") == true &&
      window.is_ab_custom_pdp == true
    ) {
      imageUrl =
        "https://cdn.shopify.com/s/files/1/0257/4522/7828/files/Rectangle_1_2.png";
    } else if (
      label.includes("Grey") == true &&
      window.is_ab_custom_pdp == true
    ) {
      imageUrl =
        "https://cdn.shopify.com/s/files/1/0257/4522/7828/files/Rectangle_1_3.png";
    } else if (
      label.includes("Mirror") == true &&
      window.is_ab_custom_pdp == true
    ) {
      imageUrl =
        "https://cdn.shopify.com/s/files/1/0257/4522/7828/files/mirror_ab_border.png";
    } else if (
      label.includes("White") == true &&
      window.is_ab_custom_pdp == true
    ) {
      imageUrl =
        "https://cdn.shopify.com/s/files/1/0257/4522/7828/files/white-color-pdp-test.png";
    }

    return (
      <SelectAbOption
        key={opt.id}
        className={selected.value === value && "checked"}
        onClick={() => onSelect(opt)}
      >
        {selected.value === value && (
          <span className="check">
            <svg
              width="18"
              height="18"
              viewBox="0 0 18 18"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <circle cx="9" cy="9" r="9" fill="#EB0067" />
              <path
                d="M5.14258 9.32145L7.71401 11.8929L13.1783 6.42859"
                stroke="white"
                strokeWidth="2"
              />
            </svg>
          </span>
        )}

        {imageUrl && <img width={24} height={24} src={imageUrl} />}

        {(splitLabel.length > 1 && (
          <div className="select-label">
            <strong>{splitLabel[0]}</strong>
            <span>{splitLabel[1]}</span>
          </div>
        )) || (
          <div className="select-label">
            <span>{splitLabel[0]}</span>
          </div>
        )}
      </SelectAbOption>
    );
  });

  return <SelectABContainer>{result}</SelectABContainer>;
};

export default function SelectOption({ optionsUtility, option }) {
  const dispatch = useDispatch();
  const handleSelectChange = async (selectedValue) => {
    console.log("Selected Value:", selectedValue);
    optionsUtility.changeOptionToLabel(option.name, selectedValue.label);
    if (option.name == "PAPER TYPE") {
      dispatch(changePaperType(selectedValue.label));
    }
    if (option.name == "BORDER") {
      const bleed = { "Full bleed": 0, '0.5"': 0.5, '1"': 1 }[
        selectedValue.value
      ];
      dispatch(changeBleed(bleed));
    }
    if (option.name == "CANVAS DEPTH") {
      dispatch(
        changeFloaterFrame({
          value: "None",
          price: 0,
          selected: false,
          label: "None",
          sku: "CP-OPT-FRAME_NONE-0000-001",
        })
      );
    }
  };

  return (
    (window.is_ab_custom_pdp && (
      <OptionSelect
        key={option.name} // Add a unique "key" prop
        onSelect={handleSelectChange}
        selected={option.values.find((value) => value.selected)}
        options={option.values}
      />
    )) || (
      <SelectContainer>
        <Select
          onChange={handleSelectChange}
          name={option.name}
          options={option.values}
          key={option.name}
          value={option.values.find((value) => value.selected)}
        />
      </SelectContainer>
    )
  );
}

const SelectABContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  gap: 16px;
  @media screen and (max-width: 768px) {
    grid-template-columns: repeat(3, 1fr);
  }
`;

const SelectAbOption = styled.div`
  background: white;
  border-radius: 8px;
  border: solid 1px #b0b0b0;
  cursor: pointer;
  position: relative;
  height: 63px;
  display: flex;
  align-items: center;
  justify-content: center;
  column-gap: 10px;

  .select-label {
    display: flex;
    flex-direction: column;

    strong {
      line-height: normal;
    }

    span {
      line-height: normal;
    }
  }

  .check {
    position: absolute;
    right: -10px;
    top: -10px;
    color: white;
  }

  &.checked {
    background: #fff3f3;
    border: solid 2px #eb0067;

    .select-label {
      strong {
        color: #373737;
        font-weight: 700;
      }
      span {
        color: #02455d;
        font-weight: 700;
      }
    }
  }

  img {
    object-fit: cover;
    border-radius: 0px;
  }
`;

const SelectContainer = styled.div`
  text-align: left;
`;
